import React from 'react'
// libs
import styled from 'styled-components'
// theme
import colors from 'themes/colors'
// icons
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// utils
import { darken } from 'polished'

export const RulesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 16px;
`

export const RuleWrapper = styled.div`
  background: ${colors.gray200};
  border-radius: 6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
`

export const AddButton = styled('div')`
  && {
    color: ${colors.blue500};
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    margin-top: 12px;
    white-space: nowrap;
    width: min-content;
    margin-bottom: 12px;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

export const CloseIcon = styled((props) => <CloseRoundedIcon {...props} />)`
  && {
    cursor: pointer;
    position: absolute;
    transform: translateY(-50%);
    right: 2px;
    top: 14px;
    height: 18px;
  }
`

export const FieldsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  > span {
    width: 50px;
  }

  > div {
    flex: 1;
  }
`
